// import { ROUTER } from "../common/constants";

const PageNotFoundComponent = () => import("../app/page-not-found/PageNotFoundComponent.vue");
const OutlookAddInComponent = () => import('../containers/outlook-add-in/OutlookAddInComponent.vue');

const EtcRoutes = [
  //#home page redirect to agenda
  { path: "/", redirect: { path : "/agenda" } },
    {
        path: "/unauthorized",
        name: "Unauthorized",
        component: PageNotFoundComponent
    },
  //#page not found
  {
    path: "*",
    name: "pageNotFound",
    component: PageNotFoundComponent
  },
  /**
   * Handle user open link form Oulook AddIn
   * then redirect to web app
  */
  {
    path: '/golink',
    name: 'outlookAddIn',
    component: OutlookAddInComponent
  }
]

export default EtcRoutes;
